import React, { useEffect } from 'react';
import { Check, CircleAlert, X } from 'lucide-react';
import './Toast.scss';

const Toast = ({ 
  isOpen, 
  type = 'success', // 'success' or 'error'
  message, 
  onClose,
  autoClose = true,
  autoCloseDelay = 3000,
  showClose = false,
  floating = true
}) => {
  useEffect(() => {
    if (autoClose && isOpen && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, autoCloseDelay);
      return () => clearTimeout(timer);
    }
  }, [isOpen, autoClose, autoCloseDelay, onClose]);

  if (!isOpen) return null;

  const isError = type === 'error';
  const Icon = isError ? CircleAlert : Check;

  return (
    <div
      className={[
        'toast-notification',
        `toast-type-${isError ? 'error' : 'success'}`,
        floating ? 'toast-floating' : '',
        isOpen ? 'toast-show' : ''
      ].filter(Boolean).join(' ')}
      role="status"
      aria-live={isError ? 'assertive' : 'polite'}
    >
      <div className="toast-icon">
        <Icon size={20} strokeWidth={2.4} />
      </div>
      <div className="toast-message">{message}</div>
      {showClose && onClose ? (
        <button 
          className="toast-close-btn"
          onClick={onClose}
          aria-label="닫기"
        >
          <X size={16} strokeWidth={2.2} />
        </button>
      ) : null}
    </div>
  );
};

export default Toast;
